module.exports = __webpack_public_path__ + "static/img/14000537.e7653a25.png";